










































































































import { Component, Vue, Prop, Emit, Watch, Ref } from 'vue-property-decorator';
import getScrollParent from '@/services/get-scroll-parent';
import vClickOutside from 'v-click-outside';
import CoreIcon from '../CoreIcon.vue';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import OptionsPopupDesktop from './OptionsPopupDesktop.vue';
import OptionsPopupMobile from './OptionsPopupMobile.vue';

@Component({
    directives: {
        clickOutside: vClickOutside.directive,
    },
    components: {
        CoreIcon,
        VuePerfectScrollbar,
        OptionsPopupDesktop,
        OptionsPopupMobile,
    },
})
export default class CoreSelect extends Vue {
    @Prop({ default: false }) public multiselect!: boolean;
    @Prop({ default: [] }) public options!: any[];
    @Prop({ default: 200 }) public maxHeight!: number;
    @Prop({ default: null }) public value!: any;
    @Prop({ default: true }) public dropdownMatchSelectWidth!: boolean;
    @Prop({ default: false }) public dropdownFloting!: boolean;
    @Prop() public selectedIndicator: any;
    @Prop({ default: [] }) public labels!: Array<string>;
    @Prop({ default: false }) public search!: boolean;
    @Prop() public searchFields!: string[];
    @Prop({ default: false }) public isCountrySelector!: boolean;

    @Ref() public searchInput!: HTMLInputElement;

    public mql = window.matchMedia('(max-width: 766px)');
    public isMobile = this.mql.matches;

    public handleMqlChangeEvent(event: MediaQueryListEvent) {
        this.isMobile = event.matches;
    }

    public open = false;
    public fromTop = false;
    public openFromTop = false;
    public optionsSelected = false;
    public selected: any[] = [];
    public setOpenPosition: any = null;
    public scrollableParent: any = null;
    public query = '';
    public timeout: any = null;
    public searchQuery = '';
    public disableClick = false;

    public get filteredOptions() {
        if (!this.searchFields) {
            return this.options;
        }
        const filtered = this.options.filter(item => {
            let matched = false;
            this.searchFields.forEach(field => {
                if (matched === false) {
                    matched = item[field]
                        .toLowerCase()
                        .includes(this.searchQuery.toLowerCase());
                }
            });
            return matched;
        });
        return filtered;
    }

    public mounted() {
        this.mql.addEventListener('change', this.handleMqlChangeEvent);

        this.optionsSelected = !!this.$scopedSlots.optionSelected;
        const height = Math.min(this.maxHeight, this.options.length * 49);
        (this.$el as HTMLElement).style.setProperty(
            '--options-max-height',
            `${height}px`
        );

        this.setOpenPosition = () => {
            const fromBottomEdge =
                window.innerHeight - this.$el.getBoundingClientRect().top;
            this.openFromTop = fromBottomEdge < this.maxHeight;
        };

        this.setOpenPosition();

        this.scrollableParent =
            getScrollParent(this.$el.parentNode) || this.$el;
        this.scrollableParent.addEventListener('scroll', this.setOpenPosition);

        if (this.multiselect) {
            this.selected = [];
            this.selected =
                this.value instanceof Array ? this.value : [this.value];
        } else if (this.value) {
            this.selected = [this.value];
        } else {
            this.selected = [];
        }
    }

    public destroyed() {
        this.mql.removeEventListener('change', this.handleMqlChangeEvent);
    }

    @Watch('open')
    public onOpenChange() {
        if (this.open) {
            this.$nextTick(() => {
                this.searchInput?.focus();
            });
        } else {
            this.searchQuery = '';
        }
    }

    public beforeDestroy() {
        this.scrollableParent.removeEventListener(
            'scroll',
            this.setOpenPosition
        );
    }

    public toggleUsingFocus() {
        this.disableClick = true;
        this.toggleSelect();

        setTimeout(() => {
            this.disableClick = false;
        }, 120);
    }

    public toggleUsingClick() {
        if (!this.disableClick) {
            this.toggleSelect();
        }
    }

    @Watch('value')
    public setSelectedValue() {
        if (this.isCountrySelector) {
            this.selected = [this.value];
        }
    }

    @Emit('change')
    public change(model: any) {
        return model;
    }
    @Emit('input')
    public select(option: any, event?: any) {
        if (this.multiselect) {
            if (event) {
                event.stopPropagation();
            }
            if (option instanceof Array) {
                this.selected = option;
            } else {
                const alreadySelectedIndex = this.selected.indexOf(option);
                alreadySelectedIndex === -1
                    ? this.selected.push(option)
                    : this.selected.splice(alreadySelectedIndex, 1);
            }
            this.change(this.selected);
            return this.selected;
        } else {
            this.selected = [option];
            this.open = false;
            this.visibleChange();
            this.change(option);
            return option;
        }
    }

    public handleSelectionChange(selectedOptions: any[]) {
        this.selected = [...selectedOptions];

        if (this.multiselect) {
            this.select(this.selected);
        } else {
            const newValue = this.selected[0] || null;
            this.select(newValue);
        }
    }

    public isSelected(option: any) {
        const isSelected = this.selected.indexOf(option) !== -1;
        if (
            this.selectedIndicator ||
            (this.selectedIndicator === undefined && this.multiselect)
        ) {
            return isSelected;
        } else {
            return false;
        }
    }

    public get optionClasses() {
        return {
            'match-select-width': this.dropdownMatchSelectWidth,
            'floating-options': this.dropdownFloting,
        };
    }

    @Emit('visibleChange')
    public visibleChange() {
        return this.open;
    }

    public preventPropagation(e: any) {
        if (this.multiselect) {
            e.stopPropagation();
        }
    }

    public toggleSelect() {
        this.open = !this.open;
        this.visibleChange();
    }

    public closeSelect() {
        this.open = false;
    }

    public handleClickOutside() {
        if (this.isMobile) return;

        this.closeSelect();
    }
}
